export const ensureArray = <T>(x: T) => [x].flat()
